import CryptoJS from 'crypto-js';

const generateInitialToken = (phoneNumber, deviceId) => {
  const secretKey = 'c3VwZXJfYXBwX2Jha2NlbGxfc2VjcmV0';

  const now = new Date(Date.now());

  // Back end needs the phone number in the format of XX XXX XX XX
  const formattedNumber = `${phoneNumber.slice(3, 5)} ${phoneNumber.slice(
    5,
    8,
  )} ${phoneNumber.slice(8, 10)} ${phoneNumber.slice(10, 12)}`;
  const ivParameter =
    `994${formattedNumber}`.split('').reverse().join('') +
    formatDate(now, 'ddMM').split('').reverse().join('');

  const trimmedIVParameter = ivParameter.replace(/\s/g, '');

  return encryptData(
    `${deviceId}$$${formattedNumber}`,
    secretKey,
    trimmedIVParameter,
  );
};

function encryptData(data, secretKey, globalSalt) {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(globalSalt);

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CTR,
  });

  return encrypted.toString();
}

const formatDate = (date, format) => {
  const options = {
    day: '2-digit',
    month: '2-digit',
  };
  const formattedDate = date.toLocaleDateString('en-US', options);
  if (format === 'ddMM') {
    return formattedDate.slice(3, 5) + formattedDate.slice(0, 2); // Rearrange the format
  }
  return formattedDate.replace(/\//g, '');
};

export default generateInitialToken;
